import Model, { ID, MODEL_LEVEL } from 'src/models/model'
import Librariable from 'src/models/model/concerns/Librariable'

export default class NewsItemClass extends Model {
  static name = 'NewsItemClass'

  static paginate = true
  static deletable = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.SiteContent]

  static define () {
    this.concerns = [Librariable]

    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      }
    }

    this.fragments = {
      select: ['id', 'name']
    }
  }
}
